import {
  RangeRefactoryTableDynamicComponent
} from './../component-table/date-refactory/range-refactory-table-dynamic.component';
import {
  RangeTimerRefactoryTableDynamicComponent
} from './../component-table/date-refactory/rangeTimer-refactory-table-dynamic.component';
import {
  RangeDateRefactoryTableDynamicComponent
} from './../component-table/date-refactory/rangeDate-refactory-table-dynamic.component';
import {
  DateTimerRefactoryTableDynamicComponent
} from './../component-table/date-refactory/dateTimer-refactory-table-dynamic.component';
import {
  TimerRefactoryTableDynamicComponent
} from './../component-table/date-refactory/timer-refactory-table-dynamic.component';
import {
  CalendarRefactoryTableDynamicComponent
} from './../component-table/date-refactory/calendar-refactory-table-dynamic.component';
import { CoordinateDynamicFormsComponent } from './../component-table/coordinates-dynamic-forms.component';
import { CheckTableComponent } from './../component-table/check-table.component';
import { ColumnsTableModalSelect, AccionModal } from './../models/modal-select.model';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Logger } from '@app/core/utilities/logger.service';
import { Component, OnInit, Input, TemplateRef, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LocalDataSource } from 'ng2-smart-table';
import { find, forEach } from 'lodash';
import { GlobalNotifierService } from '@app/core';
import { DateStringComponent } from '../component-table';
import { ModalSelectDataService } from './shared/modal-select.data.service';
import { Static } from '../util/static';

const log = new Logger('ModalSelectComponent');

type Order = 'asc' | 'desc';

type selectorType = 'TablaMaestra' | 'Tramites' | 'RadicadosSistema' | 'ConsecutivosActas' | 'TipoDocumental' | null;

interface ValueSelect {
  key: any;
  value: any;
}

@Component({
  selector: 'iw-modal-select',
  templateUrl: './modal-select.component.html',
  styleUrls: ['./modal-select.component.scss'],
  providers: [ModalSelectDataService],
})
export class ModalSelectComponent implements OnInit, AfterViewInit {
  // Clases css para el control
  @Input() class: string;
  // Id del control
  @Input() id: string;
  // Name del control
  @Input() nameControl: string;
  // Key principal de valor
  @Input() keyValue: string;
  // Placeholder del control
  @Input() placeholder = '';
  // Clase de la modal (principalmente define tamaño)
  @Input() classModal = 'modal-lg';
  // Orden de los registros en la tabla por la key asignada como principal
  @Input() orderRow: Order = 'desc';
  // Define cuando se cargan todas las columas de la forma (No funciona)
  @Input() readonly = false;
  // Define cuando se cargan todas las columas de la forma (No funciona)
  @Input() allColumns = false;
  // Define si realiza las acciones
  @Input() actionAdd = false;
  // Define si realiza las acciones
  @Input() actionUpdate = false;
  // Define si realiza las acciones
  @Input() actionDelete = false;
  // Referencia al formulario
  @Input() form: FormGroup;

  // Datos de structura del modal
  structureMasterSpecific: any = null;
  structureMasterFilter: any = null;
  structureMasterFilterHQ: any = null;

  typeSelector: selectorType = null;
  structureSelector: any = null;
  // boton de buscar
  SearchButton: any = false;
  // cargando del botonde buscar
  loadtableSearch: boolean = false;
  // cantidad de registros a consultar
  pageSize: any = 10;
  // Datos del select a mostrar en la tabla
  @Input() set data(d: Array<any>) {
    this._data = [];
    if (d && d.length) {
      d.forEach(el => {
        if (Object.keys(el).length) {
          const nEl = {};
          Object.keys(el).forEach(key => {
            if (key === this.keyValue) {
              nEl[key] = el[key];
            } else {
              nEl['_' + key] = el[key];
            }
          });
          this._data.push(nEl);
        }
      });
    }
    else if (d && d['data'] && d['data'].length) {
      d['data'].forEach((el: any) => {
        if (Object.keys(el).length) {
          const nEl = {};
          Object.keys(el).forEach(key => {
            if (key === this.keyValue) {
              nEl[key] = el[key];
            } else {
              nEl['_' + key] = el[key];
            }
          });
          this._data.push(nEl);
        }
      });
      this.structureMasterSpecific = d['structure_master_specific'];
      this.structureMasterFilter = d["structure_master_filter"];
      this.structureMasterFilterHQ = d["structure_master_filter_hq"];
      this.typeSelector = d['typeSelector'];
      this.structureSelector = d['structureSelector'];
    }
    if (this.automaticRequest) {
      if (this.orderRow === 'asc') {
        this.data.sort((a, b) => a[this.keyValue] - b[this.keyValue]);
      } else {
        this.data.sort((a, b) => b[this.keyValue] - a[this.keyValue]);
      }
      this.source.empty();
      this.source = new LocalDataSource(this.data);
      if (this.structureMasterSpecific || this.typeSelector == 'Tramites') {
        this.source.onChanged().subscribe(async (change) => {
          if (change.action === 'page' && this.source['data'].length) {
            let checkFilter = false;
            if (change.filter.filters.length) {
              forEach(change.filter.filters, f => {
                if (f.search != "") {
                  checkFilter = true;
                }
              })
            }
            if (!checkFilter) {
              this.pageChange(change.paging.page, this.typeSelector);
            }
          } else if (change.action === 'filter' && this.source['data'].length && change.filter.filters.length) {
            let checkFilter = false;
            forEach(change.filter.filters, f => {
              if (f.search != "") {
                checkFilter = true;
              }
            })
            if (checkFilter) {
              this.SearchButton = true;
            } else {
              this.SearchButton = false;
              forEach(this.data, d => {
                let checkValueS = find(this.source['data'], { id: d.id });
                if (!checkValueS) {
                  this.source.add(d);
                }
              });
              this.source.getAll().then(d => this.source.load(d))
              this.source.setPage(1);
            }
          }
        });
      }

      this.loader = false;
    }
  }
  // Datos del select a mostrar en la tabla
  _data: Array<any>;
  // Define si recarga los datos antiguos a la tabla
  @Input() refreshOldData = false;
  // Columnas de la tabla
  @Input() columns: Array<ColumnsTableModalSelect>;
  // Data temporal para las diferentes acciones en el modal
  @Input() tempDataAction: any;
  // define cuando se carga automaticamente la informacion del selector
  @Input() automaticRequest: boolean;
  // funcion para la consulta automatica
  @Input() loadData: (...arg: any[]) => any[];
  // Define la información que se mostrará en el input del selector
  @Input() label_selector: any[] = [];
  // Identifica cuando el valor seleccionado no se encuentra en la lista de opciones
  validSelectInList = true;
  // Identifica cuando el valor seleccionado no se encuentra en la lista de opciones
  searchRecordActive = false;
  // define cuando moestar el loader
  loader = false;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Registro seleccionado
  dataSelect: ValueSelect = {
    key: null,
    value: null
  };
  // Registro a seleccionar
  rowSelect: any;
  // Configuracion de la tabla
  settings = {
    mode: 'external',
    noDataMessage: 'No hay datos',
    actions: false,
    attr: {
      class: 'table-bordered table-hover'
    },
  };
  // Data formateada para motrar en tabla
  source: LocalDataSource;

  // Template para el modal de la lista de seleccion del select
  @ViewChild('templateModalSelect') private templateModalSelect: TemplateRef<any>;
  // Salida del evento de agregar
  @Output() add: EventEmitter<AccionModal> = new EventEmitter();
  // Salida del evento de actualizar
  @Output() update: EventEmitter<AccionModal> = new EventEmitter();
  // Salida del evento de eliminar
  @Output() delete: EventEmitter<AccionModal> = new EventEmitter();
  // Salida del campo seleccionado
  @Output() selectedRow: EventEmitter<any> = new EventEmitter();

  constructor(
    private modalService: BsModalService,
    private gns: GlobalNotifierService,
    private msds: ModalSelectDataService,
  ) { }

  async ngOnInit() {
    if (Array.isArray(this.data)) {
      if (this.orderRow === 'asc') {
        this.data.sort((a, b) => a[this.keyValue] - b[this.keyValue]);
      } else {
        this.data.sort((a, b) => b[this.keyValue] - a[this.keyValue]);
      }
      this.source = new LocalDataSource(this.data);
    }
    if (this.automaticRequest) {
      if (this.form.controls[this.nameControl].value) {
        await this.searchRecord(this.form.controls[this.nameControl].value);
      }
    }
    this.loadingValueSelect();
    this.form.controls[this.nameControl].valueChanges.subscribe(async data => {
      if (!this.searchRecordActive) {
        if (this.automaticRequest) {
          this.searchRecordActive = true;
          if (data) {
            await this.searchRecord(data);
          }
          this.searchRecordActive = false;
        }
        this.loadingValueSelect();
      }
    });
    this.form.controls[this.nameControl];
  }

  get data(): Array<any> {
    return this._data;
  }

  ngAfterViewInit(): void {
    this.gns.listen().subscribe(list => {
      log.debug(list);
      if (list.action === 'loadingData' && list.destiny === ('ModalSelectComponent-' + this.nameControl)) {
        if (Array.isArray(list.data)) {
          this.data = list.data;
          if (this.orderRow === 'asc') {
            this.data.sort((a, b) => a[this.keyValue] - b[this.keyValue]);
          } else {
            this.data.sort((a, b) => b[this.keyValue] - a[this.keyValue]);
          }
          this.source = new LocalDataSource(this.data);
          this.source.refresh();
          if (this.dataSelect && this.dataSelect.key && this.form.controls[this.nameControl]) {
            const dataSearch = {};
            dataSearch[this.keyValue] = this.form.controls[this.nameControl].value;
            const rowSelect = find(this.data, dataSearch);
            if (!rowSelect) {
              this.dataSelect = {
                key: null,
                value: null
              };
            }
          }
          // Eliminar este mensaje
          this.gns.delete(list.index);
          this.rowSelect = null;
          log.debug(`Nueva data cargada`);
        }
      } else if (list.action === 'changePropertie' && list.destiny === ('ModalSelectComponent-' + this.nameControl)) {
        Object.keys(list.data).forEach(key => {
          this[key] = list.data[key];
          if (key === 'columns') {
            this.loadingTable();
          }
        });
      }
    });
  }

  /**
   * Abre el modal para seleccionar la opcion
   *
   * @param {*} data
   * @memberof ModalSelectComponent
   */
  async onClickMe(data: any) {
    if (!this.form.controls[this.nameControl].disabled && !this.readonly) {
      this.loadingTable();
      log.debug('form: ', this.form.controls[this.nameControl].value, 'event: ', data);
      if (this.refreshOldData) {
        this.source.empty();
        this.source = new LocalDataSource(this.data);
        this.source.refresh();
      }
      this.modalRef = this.modalService.show(
        this.templateModalSelect,
        {
          class: this.classModal,
          backdrop: 'static',
          keyboard: false
        }
      );
      if (this.automaticRequest) {
        this.loader = true;
        const resp = await this.loadData();
        Object.keys(resp).forEach(key => {
          this[key] = resp[key];
          if (key === 'columns') {
            this.loadingTable();
          }
        });
      }
      this.gns.set<any>({
        source: 'ModalSelectComponent',
        destiny: 'RefactorDynamic',
        action: 'loadingData',
        eventTriggered: 'click',
        data: true
      }, true);
    }
  }

  /**
   * Cierra el modal de las opciones
   *
   * @memberof ModalSelectComponent
   */
  closeModal() {
    this.rowSelect = null;
    this.settings['columns'] = {};
    this.modalRef.hide();
    this.source.empty();
    this.SearchButton = false;
    this.gns.set<any>({
      source: 'ModalSelectComponent',
      destiny: 'RefactorDynamic',
      action: 'loadingData',
      eventTriggered: 'click',
      data: false
    }, true);
    this.loadingValueSelect();
  }

  /**
   * Carga la estructura de la tabla
   *
   * @memberof ModalSelectComponent
   */
  loadingTable() {
    const self = this;
    var accents = require('remove-accents');
    const columns = {};
    if (this.columns && this.columns.length) {
      this.columns.forEach(column => {
        if (column.type) {
          switch (column.type) {
            case 'textarea':
              columns['_' + String(column.key)] = {
                editable: false,
                addable: false,
                sort: false,
                title: column.label,
                filter: {
                  inputClass: 'form-control',
                },
              };
              break;
            case 'checkbox':
              columns['_' + String(column.key)] = {
                title: column.label,
                sort: true,
                filter: false,
                type: 'custom',
                renderComponent: CheckTableComponent,
              };
              break;
            case 'coordenadas':
              columns['_' + String(column.key)] = {
                title: column.label,
                sort: true,
                filter: {
                  inputClass: 'form-control',
                },
                type: 'custom',
                renderComponent: CoordinateDynamicFormsComponent,
              };
              break;
            case 'date-time-picker':
              columns['_' + String(column.key)] = {
                title: column.label,
                sort: true,
                filter: {
                  inputClass: 'form-control',
                },
                type: 'custom',
              };
              switch (column.category) {
                case 'calendar':
                  columns['_' + String(column.key)]['renderComponent'] = CalendarRefactoryTableDynamicComponent;
                  break;
                case 'timer':
                  columns['_' + String(column.key)]['renderComponent'] = TimerRefactoryTableDynamicComponent;
                  break;
                case 'dateTimer':
                  columns['_' + String(column.key)]['renderComponent'] = DateTimerRefactoryTableDynamicComponent;
                  break;
                case 'rangeDate':
                  columns['_' + String(column.key)]['renderComponent'] = RangeDateRefactoryTableDynamicComponent;
                  break;
                case 'rangeTime':
                  columns['_' + String(column.key)]['renderComponent'] = RangeTimerRefactoryTableDynamicComponent;
                  break;
                default:
                  columns['_' + String(column.key)]['renderComponent'] = RangeRefactoryTableDynamicComponent;
                  break;
              }
              break;
            case 'dateString':
              columns['_' + String(column.key)] = {
                title: column.label,
                sort: true,
                filter: {
                  inputClass: 'form-control',
                },
                renderComponent: DateStringComponent,
                type: 'custom',
              };
              break;
            default:
              columns['_' + String(column.key)] = {
                editable: false,
                addable: false,
                title: column.label,
                filter: {
                  inputClass: 'form-control',
                },
                filterFunction: (cell?: any, search?: string) => {
                  if (cell) {
                    if (typeof (cell) == 'string') {
                      return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
                    } else {
                      return cell.toString().includes(search) ? true : false;
                    }
                  } else {
                    return false;
                  }
                }
              };
              break;
          }
        } else {
          if (!column.alias) {
            columns['_' + String(column.key)] = {
              editable: false,
              addable: false,
              title: column.label,
              filter: {
                inputClass: 'form-control',
              },
            };
          } else {
            columns['_' + String(column.alias)] = {
              editable: false,
              addable: false,
              title: column.label,
              filter: {
                inputClass: 'form-control',
              },
            };
          }
        }
      });
    }
    this.settings['columns'] = columns;
  }

  /**
   * Carga la seleccion del registro en el campo principal
   *
   * @memberof ModalSelectComponent
   */
  loadingValueSelect() {
    if (this.data && this.data.length) {
      const dataSearch = {};
      dataSearch[this.keyValue] = this.form.controls[this.nameControl].value;
      const rowSelect = find(this.data, dataSearch);
      if (rowSelect) {
        let key = '';
        let value = '';
        if (this.columns && this.columns.length) {
          const cols: ColumnsTableModalSelect[] = [];
          if (!this.label_selector.length) {
            this.columns.forEach(column => {
              if (column.view !== false) {
                cols.push(column);
              }
            });
          } else {
            this.columns.forEach(column => {
              this.label_selector.forEach(ls => {
                if (column.view !== false && ls.alias == column.alias) {
                  column['orden'] = ls['orden'];
                  cols.push(column);
                }
              })
            });
            cols.sort(function (a: any, b: any) {
              if (a.orden > b.orden) {
                return 1;
              }
              if (a.orden < b.orden) {
                return -1;
              }
              return 0;
            });
          }

          if (cols && cols.length) {
            cols.forEach((column, index) => {
              if (column.type) {
                switch (column.type) {
                  case 'date-time-picker':
                    let val = '';
                    switch (column.category) {
                      case 'calendar':
                        if (rowSelect['_' + column.key]) {
                          val += new Date(rowSelect['_' + column.key]).toLocaleDateString();
                        }
                        break;
                      case 'timer':
                        if (rowSelect['_' + column.key]) {
                          val += new Date(rowSelect['_' + column.key]).toLocaleTimeString();
                        }
                        break;
                      case 'dateTimer':
                        if (rowSelect[column.key]) {
                          val += new Date(rowSelect['_' + column.key]).toLocaleDateString() + ' ' +
                            new Date(rowSelect['_' + column.key]).toLocaleTimeString();
                        }
                        break;
                      case 'rangeDate':
                        if (rowSelect['_' + column.key]) {
                          val += new Date(rowSelect['_' + column.key][0]).toLocaleDateString();
                          val += ' - ' + new Date(rowSelect['_' + column.key][1]).toLocaleDateString();
                        }
                        break;
                      case 'rangeTime':
                        if (rowSelect['_' + column.key]) {
                          val += new Date(rowSelect['_' + column.key][0]).toLocaleTimeString();
                          val += ' - ' + new Date(rowSelect['_' + column.key][1]).toLocaleTimeString();
                        }
                        break;
                      default:
                        if (rowSelect['_' + column.key]) {
                          val += new Date(rowSelect['_' + column.key][0]).toLocaleDateString() + ' ' +
                            new Date(rowSelect['_' + column.key][0]).toLocaleTimeString();
                          val += ' - ' + new Date(rowSelect['_' + column.key][1]).toLocaleDateString() + ' ' +
                            new Date(rowSelect['_' + column.key][1]).toLocaleTimeString();
                        }
                        break;
                    }
                    if (val) {
                      value += val;
                    } else {
                      value += 'No aplica';
                    }
                    break;
                  default:
                    if (rowSelect['_' + column.key]) {
                      value += rowSelect['_' + column.key];
                    } else {
                      value += 'No aplica';
                    }
                    break;
                }
              } else {
                if (!column.alias) {
                  if (rowSelect['_' + column.key]) {
                    value += rowSelect['_' + column.key];
                  } else {
                    value += 'No aplica';
                  }
                } else {
                  if (rowSelect['_' + column.alias]) {
                    value += rowSelect['_' + column.alias];
                  } else {
                    value += 'No aplica';
                  }
                }
              }
              if (index < (cols.length - 1)) {
                value += ' / ';
              }
            });
          }
        }
        key = rowSelect[this.keyValue];
        this.dataSelect = {
          key: key,
          value: value
        };
        this.validSelectInList = true;
      } else {
        this.dataSelect = {
          key: null,
          value: null
        };
        if (this.form.controls[this.nameControl].value) {
          this.validSelectInList = false;
          this.form.controls[this.nameControl].setValue(null);
        }
      }
    } else {
      this.dataSelect = {
        key: null,
        value: null
      };
      if (this.form.controls[this.nameControl].value) {
        this.validSelectInList = false;
        this.form.controls[this.nameControl].setValue(null);
      }
    }
  }

  /**
   * Controla la accion de seleccionar un registro en la tabla de opciones
   *
   * @param {*} row
   * @memberof ModalSelectComponent
   */
  rowSelected(row: any) {
    if (!this.rowSelect || row.data[this.keyValue] !== this.rowSelect[this.keyValue]) {
      this.rowSelect = row.data;
    } else {
      this.rowSelect = null;
    }
    log.debug('registro seleccionado:', this.rowSelect);
  }

  /**
   * Controla la accion de marcar como seleccionado el registro seleccionado
   *
   * @memberof ModalSelectComponent
   */
  selected() {
    if (this.rowSelect) {
      this.form.controls[this.nameControl].setValue(this.rowSelect[this.keyValue]);
      this.selectedRow.emit(this.rowSelect);
      this.SearchButton = false;
      this.loadingValueSelect();
      this.closeModal();
    }
  }

  /**
   * Controla la accion de buscar de la tabla
   *
   * @memberof ModalSelectComponent
   */
  async SearchData() {
    let filters: any[] = [];
    if (this.source['filterConf'] && this.source['filterConf'].filters.length) {
      forEach(this.source['filterConf'].filters, (fil: any) => {
        if (fil.search != "") { filters.push({ "column": fil.field.substring(1), "valor": fil.search }) }
      })
      if (filters.length) {
        this.loadtableSearch = true;
        if (this.typeSelector == 'Tramites') {
          await this.msds.getSelectorUtils(this.structureSelector["tramites"],
            this.structureSelector["estructura"],
            this.structureSelector["filtro_tramite"],
            this.structureSelector["campo_selector_dinamico"] ? this.structureSelector["campo_selector_dinamico"] : false,
            this.structureSelector["selector_dinamico"] ? this.structureSelector["selector_dinamico"] : null,
            null,
            filters, null, null).then(async data => {
              if (this.source) {
                let dataModalSelector: Array<any> = [];
                data.forEach((row) => {
                  let d = Static.copyObjet(row);
                  d["key"] = row.id;
                  d["value"] = row.id;
                  dataModalSelector.push(d);
                });
                dataModalSelector.forEach((el: any) => {
                  if (Object.keys(el).length) {
                    const nEl = {};
                    Object.keys(el).forEach(key => {
                      if (key === this.keyValue) {
                        nEl[key] = el[key];
                      } else {
                        nEl['_' + key] = el[key];
                      }
                    });
                    let checkValueData = find(this.data, { id: nEl['id'] })
                    if (!checkValueData) {
                      this.data.push(nEl);
                    }
                  }
                });
                forEach(this.data, d => {
                  let checkValueS = find(this.source['data'], { id: d.id });
                  if (!checkValueS) {
                    this.source.add(d);
                  }
                });
                this.source.getAll().then(d => this.source.load(d))
              }
            })
        } else {
          await this.msds.getColumnsSpecificMasterTable(this.structureMasterSpecific, this.structureMasterFilter, null, this.structureMasterFilterHQ, null, null, filters).then(async data => {
            if (this.source) {
              let dataModalSelector: Array<any> = [];
              data.forEach((row) => {
                let d = Static.copyObjet(row.valores);
                d["id"] = row.id;
                dataModalSelector.push(d);
              });
              dataModalSelector.forEach((el: any) => {
                if (Object.keys(el).length) {
                  const nEl = {};
                  Object.keys(el).forEach(key => {
                    if (key === this.keyValue) {
                      nEl[key] = el[key];
                    } else {
                      nEl['_' + key] = el[key];
                    }
                  });
                  let checkValueData = find(this.data, { id: nEl['id'] })
                  if (!checkValueData) {
                    this.data.push(nEl);
                  }
                }
              });
              forEach(this.data, d => {
                let checkValueS = find(this.source['data'], { id: d.id });
                if (!checkValueS) {
                  this.source.add(d);
                }
              });
              this.source.getAll().then(d => this.source.load(d))
            }
          })
        }
        this.loadtableSearch = false;
      }

    }
  }

  /**
   * Controla la accion de agregar
   *
   * @memberof ModalSelectComponent
   */
  actAdd() {
    this.rowSelect = null;
    this.SearchButton = false;
    this.add.emit({
      accion: 'agregar',
      temporalData: this.tempDataAction
    });
  }

  /**
   * Controla la accion de modificar
   *
   * @memberof ModalSelectComponent
   */
  actUpdate() {
    if (this.rowSelect) {
      this.add.emit({
        accion: 'actualizar',
        temporalData: this.tempDataAction,
        registroSeleccionado: this.rowSelect
      });
    }
  }

  /**
   * Controla la accion de eliminar
   *
   * @memberof ModalSelectComponent
   */
  actDelete() {
    if (this.rowSelect) {
      this.add.emit({
        accion: 'eliminar',
        temporalData: this.tempDataAction,
        registroSeleccionado: this.rowSelect
      });
    }
  }

  /**
   * Consulta el registro del valor
   *
   * @private
   * @param {*} data
   * @memberof ModalSelectComponent
   */
  private searchRecord(data: any): Promise<boolean> {
    return new Promise(async (resolve) => {
      const dataSearch = {};
      dataSearch[this.keyValue] = data;
      const rowSelect = find(this.data, dataSearch);
      if (!rowSelect) {
        if (this.automaticRequest) {
          this.loader = true;
          const resp = await this.loadData(data);
          Object.keys(resp).forEach(key => {
            this[key] = resp[key];
            if (key === 'columns') {
              this.loadingTable();
            }
          });
        }
      }
      resolve(true);
    });
  }

  async pageChange(pageIndex: any, type?: string) {
    let loadedRecordCount = this.source.count();
    let lastRequestedRecordIndex = pageIndex * this.pageSize;

    if (loadedRecordCount <= lastRequestedRecordIndex) {
      let startIndex = loadedRecordCount + 1;
      let recordCount = lastRequestedRecordIndex + 100; //extra 100 records improves UX.

      if (type == 'Tramites') {
        await this.msds.getSelectorUtils(this.structureSelector["tramites"],
          this.structureSelector["estructura"],
          this.structureSelector["filtro_tramite"],
          this.structureSelector["campo_selector_dinamico"] ? this.structureSelector["campo_selector_dinamico"] : false,
          this.structureSelector["selector_dinamico"] ? this.structureSelector["selector_dinamico"] : null,
          null,
          null, startIndex, recordCount).then(async data => {
            if (this.source) {
              let dataModalSelector: Array<any> = [];
              data.forEach((row) => {
                let d = Static.copyObjet(row);
                d["key"] = row.id;
                // d["value"] = row.id;
                dataModalSelector.push(d);
              });
              dataModalSelector.forEach((el: any) => {
                if (Object.keys(el).length) {
                  const nEl = {};
                  Object.keys(el).forEach(key => {
                    if (key === this.keyValue) {
                      nEl[key] = el[key];
                    } else {
                      nEl['_' + key] = el[key];
                    }
                  });
                  let checkValueData = find(this.data, { id: nEl['id'] })
                  if (!checkValueData) {
                    this.data.push(nEl);
                  }
                }
              });
              forEach(this.data, d => {
                let checkValueS = find(this.source['data'], { id: d.id });
                if (!checkValueS) {
                  this.source.add(d);
                }
              });
              this.source.getAll().then(d => this.source.load(d))
            }
          })

      } else {
        await this.msds.getColumnsSpecificMasterTable(this.structureMasterSpecific, this.structureMasterFilter, null, this.structureMasterFilterHQ, startIndex, recordCount).then(async data => {
          if (this.source) {
            let dataModalSelector: Array<any> = [];
            data.forEach((row) => {
              let d = Static.copyObjet(row.valores);
              d["id"] = row.id;
              d["value"] = row.id;
              dataModalSelector.push(d);
            });
            dataModalSelector.forEach((el: any) => {
              if (Object.keys(el).length) {
                const nEl = {};
                Object.keys(el).forEach(key => {
                  if (key === this.keyValue) {
                    nEl[key] = el[key];
                  } else {
                    nEl['_' + key] = el[key];
                  }
                });
                let checkValueData = find(this.data, { id: nEl['id'] })
                if (!checkValueData) {
                  this.data.push(nEl);
                }
              }
            });
            forEach(this.data, d => {
              let checkValueS = find(this.source['data'], { id: d.id });
              if (!checkValueS) {
                this.source.add(d);
              }
            });
            this.source.getAll().then(d => this.source.load(d))
          }
        })
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal-select/modal-select.component.ts